import { render, staticRenderFns } from "./SharedMedias.vue?vue&type=template&id=2a3dd40f&"
import script from "./SharedMedias.vue?vue&type=script&lang=js&"
export * from "./SharedMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports